import { render } from "./MRoom.vue?vue&type=template&id=7f99b971"
import script from "./MRoom.vue?vue&type=script&lang=js"
export * from "./MRoom.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__